module.exports = __webpack_public_path__ + "static/media/course4.62aa8d3f.png";